import * as types from "../types/index";
import { core } from "./core";

export const getItemTypes = (queryString) => {
  if (!queryString) {
    queryString = "limit=100&offset=0";
  }
  return core.API(
    "GET",
    `/item-types?${queryString}`,
    types.GET_ITEM_TYPES,
    types.GET_ITEM_TYPES_SUCCESS,
    types.GET_ITEM_TYPES_FAILURE
  );
};

export const createItemType = (data) => {
  return core.API(
    "POST",
    `/item-type`,
    types.CREATE_ITEM_TYPES,
    types.CREATE_ITEM_TYPES_SUCCESS,
    types.CREATE_ITEM_TYPES_FAILURE,
    data
  );
};

export const deleteItemType = (id) => {
  return core.API(
    "DELETE",
    `/item-type/${id}`,
    types.DELETE_ITEM_TYPES,
    types.DELETE_ITEM_TYPES_SUCCESS,
    types.DELETE_ITEM_TYPES_FAILURE
  );
};

export const updateItemType = (id, data) => {
  return core.API(
    "PUT",
    `/item-type/${id}/`,
    types.PUT_ITEM_TYPES,
    types.PUT_ITEM_TYPES_SUCCESS,
    types.PUT_ITEM_TYPES_FAILURE,
    data
  );
};

export const getUnitList = () => {
  return core.API(
    "GET",
    `/measurements`,
    types.GET_UNITS,
    types.GET_UNITS_SUCCESS,
    types.GET_UNITS_FAILURE
  );
};

export const getItems = (queryString) => {
  return core.API(
    "GET",
    `/items${queryString ? `?${queryString}` : ""}`,
    types.GET_ITEMS,
    types.GET_ITEMS_SUCCESS,
    types.GET_ITEMS_FAILURE
  );
};

export const createItem = (data) => {
  return core.API(
    "POST",
    `/item`,
    types.CREATE_ITEM,
    types.CREATE_ITEM_SUCCESS,
    types.CREATE_ITEM_FAILURE,
    data
  );
};

export const deleteItem = (id) => {
  return core.API(
    "DELETE",
    `/item/${id}`,
    types.DELETE_ITEM,
    types.DELETE_ITEM_SUCCESS,
    types.DELETE_ITEM_FAILURE
  );
};

export const deleteItems = (data) => {
  return core.API(
    "DELETE",
    `/item/destroy-all`,
    types.DELETE_ITEMS,
    types.DELETE_ITEMS_SUCCESS,
    types.DELETE_ITEMS_FAILURE,
    data
  );
};

export const updateItem = (id, data) => {
  return core.API(
    "PUT",
    `/item/${id}/`,
    types.PUT_ITEM,
    types.PUT_ITEM_SUCCESS,
    types.PUT_ITEM_FAILURE,
    data
  );
};

export const getItemTypeCategoryList = () => {
  return core.API(
    "GET",
    `/item-type-categories`,
    types.GET_ITEM_TYPE_CATEGORIES,
    types.GET_ITEM_TYPE_CATEGORIES_SUCCESS,
    types.GET_ITEM_TYPE_CATEGORIES_FAILURE
  );
};

export const createItemTypeCategory = (data) => {
  return core.API(
    "POST",
    `/item-type-category`,
    types.CREATE_ITEM_TYPE_CATEGORY,
    types.CREATE_ITEM_TYPE_CATEGORY_SUCCESS,
    types.CREATE_ITEM_TYPE_CATEGORY_FAILURE,
    data
  );
};

export const getItemSummary = (id, queryString) => {
  return core.API(
    "GET",
    `/project/${id}/planned-used-costs/${queryString ? `?${queryString}` : ""}`,
    types.GET_ITEM_SUMMARY,
    types.GET_ITEM_SUMMARY_SUCCESS,
    types.GET_ITEM_SUMMARY_FAILURE
  );
};
